import { APIContentResponse, APIContentRequest } from './types';

export async function getContent({ tags: filterTags, brand }: APIContentRequest): Promise<APIContentResponse> {
  const response: APIContentResponse = await fetch(process.env.PUBLIC_URL + `/assets/${brand}/content.json`).then(
    response => response.json(),
  );

  // TODO:- move to selector when we use real API
  return {
    ...response,
    content: response.content.filter(({ tags }) =>
      !filterTags ? true : filterTags.every(label => tags.includes(label)),
    ),
  };
}
